var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCulebroTvIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "59px",
    viewBox: "0 0 64 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ETV") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apple-TV",
    transform: "translate(-991.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ETV",
    transform: "translate(991.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pantalla-de-television",
    transform: "translate(0.000000, 0.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.1472941,0 L4.85270588,0 C2.176,0 0,2.176 0,4.85270588 L0,45.0936471 C0,47.769098 2.176,49.9463529 4.85270588,49.9463529 L22.9659608,49.9463529 L22.9659608,54.9659608 L19.5789804,54.9659608 C18.470902,54.9659608 17.5686275,55.8632157 17.5686275,56.9700392 C17.5686275,58.0781176 18.470902,58.9803922 19.5789804,58.9803922 L44.4210196,58.9803922 C45.529098,58.9803922 46.4313725,58.0781176 46.4313725,56.9700392 C46.4313725,55.8632157 45.529098,54.9659608 44.4210196,54.9659608 L41.0340392,54.9659608 L41.0340392,49.9463529 L59.1472941,49.9463529 C61.824,49.9463529 64,47.769098 64,45.0936471 L64,4.85270588 C64,2.176 61.824,0 59.1472941,0 Z M26.9803922,54.9659608 L37.0196078,54.9659608 L37.0196078,49.9463529 L26.9803922,49.9463529 L26.9803922,54.9659608 Z M59.9855686,45.0936471 C59.9855686,45.5541961 59.6078431,45.9319216 59.1472941,45.9319216 L4.85270588,45.9319216 C4.39215686,45.9319216 4.01443137,45.5541961 4.01443137,45.0936471 L4.01443137,4.85270588 C4.01443137,4.39215686 4.39215686,4.01443137 4.85270588,4.01443137 L59.1472941,4.01443137 C59.6078431,4.01443137 59.9855686,4.39215686 59.9855686,4.85270588 L59.9855686,45.0936471 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1179615,21.6188252 C37.0524689,13.1587842 30.1448663,6.24747362 21.6893995,6.18198097 C13.2339326,6.11648831 6.43251465,12.9216143 6.4980073,21.3816553 C6.56349996,29.8416963 13.4711025,36.7530068 21.9265694,36.8184995",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 5.51276417,
    transform: "translate(21.807750, 21.500006) rotate(-46.000000) translate(-21.807750, -21.500006) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#000000",
    transform: "translate(21.521733, 18.903064) rotate(-315.000000) translate(-21.521733, -18.903064) ",
    points: "19.5225758 3.0700548 23.7017366 2.43903134 23.8483377 35.3670967 19.1951276 35.2054568"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#000000",
    transform: "translate(36.882509, 27.908832) rotate(-316.000000) translate(-36.882509, -27.908832) ",
    points: "36.955484 23.1725289 43.4811434 32.5429706 30.2838739 32.6451361"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulebroTvIcon);
export default __webpack_public_path__ + "static/media/culebroTVIcon.3d6fafeda24e14c767da50f181f95e11.svg";
export { ForwardRef as ReactComponent };